import React from 'react';
import Button from '../../../../reusableComponents/buttons/button12';
import ProfileImage from '../../../../../assets/dashboard/studentProfile/image.png';

const PersonalImageCard = () => {
  return (
    <div className="flex flex-col justify-center items-center sm:items-start gap-4 sm:gap-6 w-full">
      <div className="w-full max-w-[300px] md:max-w-full rounded overflow-hidden">
        <img
          src={ProfileImage}
          alt="Profile"
          className="w-full h-auto object-cover"
        />
      </div>
      
      {/* Edit Text and Buttons */}
      <div className="w-full flex flex-col justify-start items-center sm:items-start gap-4">
        <div className="text-center sm:text-left text-black text-base font-bold px-1">
          Edit your photo
        </div>
        
        <div className="flex flex-wrap justify-center sm:justify-start items-center gap-2">
          {/* Update Button */}
          <Button 
            type="Primary"
            size="Compact"
            state="Hover"
            variant="Default"
            text="Update"
          />
          
          {/* Delete Button */}
          <Button 
            type="Secondary"
            size="Compact"
            state="Default"
            variant="Default"
            text="Delete"
          />
        </div>
      </div>
    </div>
  );
};

export default PersonalImageCard;